import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('RoomSetupStore')
@observer
class RoomSetupSearchRoomModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Room',
                dataIndex: 'roomName',
                key: 'roomName',
                width: '90%'
            },
            {
                title: 'Action',
                dataIndex: 'roomId',
                key: 'roomId',
                width: '10%',
                render: record => {
                    const { roomId } = this.props.RoomSetupStore;

                    if (roomId !== record)
                    return (
                        <span>
                            <Button onClick={() => this.selectRoomOnClick(record)} type='primary'>
                                Select
                            </Button>
                        </span>
                    )
                },
            },
        ]
    }

    // ON CHANGE

    roomOnChange = e => {
        this.props.RoomSetupStore.setRoomSearchValue(e.target.value);
        this.props.RoomSetupStore.searchRoom();
    }

    // ON CLICK

    selectRoomOnClick = roomId => {
        this.props.RoomSetupStore.searchRoomSelected(roomId);
        this.props.RoomSetupStore.setShowRoomSearchModal(false);
    }

    render() {
        const {
            roomFilter,
            roomSearchValue
        } = this.props.RoomSetupStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Room' value={roomSearchValue} onChange={this.roomOnChange} />
                <Table columns={this.getColumns()} dataSource={roomFilter} />
            </React.Fragment>
        )
    }
}

export default RoomSetupSearchRoomModalPage;